import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { LeadForm } from './LeadForm';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const scrollToTrips = () => {
    const tripsElement = document.getElementById('featured-trips');
    if (tripsElement) {
      tripsElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-[90vh] flex items-center pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden bg-neutral-50" data-id="element-141">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-142">
        <img src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Group travelers enjoying a scenic view in Switzerland" className="w-full h-full object-cover" data-id="element-143" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/80 to-transparent lg:to-white/10" data-id="element-144"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent lg:hidden" data-id="element-145"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-146">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-147">
          {/* Left Content */}
          <motion.div className="lg:col-span-7 max-w-2xl" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-148">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6" data-id="element-149">
              <span className="flex h-2 w-2 rounded-full bg-primary mr-2" data-id="element-150"></span>
              Trusted by 5,000+ Group Organizers
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-primary leading-tight mb-6" data-id="element-151">
              Plan a memorable group trip —{' '}
              <span className="text-teal" data-id="element-152">we'll handle the details.</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-153">
              From faith communities to alumni groups and senior clubs, Premier
              World Discovery helps organizers choose the right itinerary,
              dates, and inclusions — with a dedicated team supporting you
              end-to-end.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-154">
              <Button size="lg" onClick={scrollToForm} className="shadow-lg shadow-primary/20" data-id="element-155">
                Request a Group Proposal
              </Button>
              <Button variant="outline" size="lg" onClick={scrollToTrips} className="bg-white/50 backdrop-blur-sm" data-id="element-156">
                Browse 2026 Trips
              </Button>
            </div>

            <div className="mt-12 flex items-center text-sm text-gray-600" data-id="element-157">
              <div className="flex -space-x-2 mr-4" data-id="element-158">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-159">
                    <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-160" />
                  </div>)}
              </div>
              <p data-id="element-161">Join thousands of organizers planning with us this year.</p>
            </div>
          </motion.div>

          {/* Right Content - Form */}
          <motion.div className="lg:col-span-5" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-162">
            <LeadForm data-id="element-163" />
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-primary hidden lg:flex flex-col items-center cursor-pointer" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} onClick={() => window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    })} data-id="element-164">
        <span className="text-sm font-medium mb-2" data-id="element-165">Scroll to explore</span>
        <ArrowDown size={20} data-id="element-166" />
      </motion.div>
    </section>;
}